import {
	getMessagesForLocale,
	getDefaultLocale,
	supportedLocales,
	defaultLocale,
	getContactInformation,
} from './helpers';
import FormattedMessage from './FormattedMessage';

export {
	FormattedMessage,
	getMessagesForLocale,
	getDefaultLocale,
	defaultLocale,
	supportedLocales,
	getContactInformation,
};



// WEBPACK FOOTER //
// ./src/ui/i18n/index.js